import React from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast, successToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserTableControls from "./components/UserTableControls";
import UserNameLink from "./components/UserNameLink";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  InputRightAddon,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Select,
} from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview } from "react-icons/gr";
function KycUser() {
  const [data, setData] = useState([]);
  const [newID, setNewID] = useState(null);
  const [rejectType, setRejectType] = useState("kyc");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const btnRef = React.useRef();

  const [rejectUser, setRejectUser] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const {
    isOpen: isRejectOpen,
    onOpen: onRejectOpen,
    onClose: onRejectClose,
  } = useDisclosure();

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [statusType, setStatusType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [sortType, setSortType] = useState(""); // name | date
  const [filterStatus, setFilterStatus] = useState(""); // verified | pending | rejected
  const [page, setPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    async function fetchData() {
      axios.get("getAllKycUsers").then((response) => {
        console.log(response?.data);
        setData(response?.data?.result);
      });
    }
    fetchData();
  }, []);
  const finalData = useMemo(() => {
    let filtered = [...data];

    // 🔍 SEARCH
    if (searchText) {
      filtered = filtered.filter(
        (item) =>
          item.holderName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.email?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.mobile?.toString().includes(searchText),
      );
    }

    // 🎯 FILTER (status)
    if (filterStatus) {
      filtered = filtered.filter((item) => item.status === filterStatus);
    }

    // 🔃 SORT
    if (sortType === "name") {
      filtered.sort((a, b) => a.holderName?.localeCompare(b.holderName));
    }

    if (sortType === "date") {
      filtered.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
    }

    return filtered;
  }, [data, searchText, sortType, filterStatus]);

  useEffect(() => {
    setPage(1);
  }, [searchText, sortType, filterStatus]);

  const paginatedData = useMemo(() => {
    const start = (page - 1) * pageSize;
    return finalData.slice(start, start + pageSize);
  }, [finalData, page]);

  const statusCount = useMemo(() => {
  let counts = {
    pending: 0,
    verified: 0,
    rejected: 0,
  };

  data.forEach((item) => {
    if (item.status === "pending") counts.pending++;
    if (item.status === "verified") counts.verified++;
    if (item.status === "rejected") counts.rejected++;
  });

  return counts;
}, [data]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "sr",
        Cell: ({ row }) => <Cell text={row.index + 1} />,
      },

      {
        Header: "Holder Name",
        accessor: "holderName",
        Cell: ({ value, row: { original } }) => (
          <UserNameLink userId={original?.user} name={value} />
        ),
      },

      {
        Header: "Email",
        accessor: "email",
        Cell: ({ value }) => <Cell text={value || "-"} />,
      },

      {
        Header: "Mobile",
        accessor: "mobile",
        Cell: ({ value }) => <Cell text={value} />,
      },

      {
        Header: "Bank Name",
        accessor: "bankName",
        Cell: ({ value }) => <Cell text={value} />,
      },

      {
        Header: "Account No",
        accessor: "accountNo",
        Cell: ({ value }) => <Cell text={value} />,
      },

      {
        Header: "IFSC",
        accessor: "ifsc",
        Cell: ({ value }) => <Cell text={value} />,
      },

      {
  Header: "Status",
  accessor: "status",
  Cell: ({ value }) => {
    let colorClass = "";

    if (value === "pending") {
      colorClass = "text-yellow-600 font-bold";
    }
    if (value === "verified") {
      colorClass = "text-green-600 font-bold";
    }
    if (value === "rejected") {
      colorClass = "text-red-600 font-bold";
    }

   return (
  <span
    className={`px-2 py-1 rounded text-white text-xs ${
      value === "pending"
        ? "bg-yellow-500"
        : value === "verified"
        ? "bg-green-500"
        : "bg-red-500"
    }`}
  >
    {value}
  </span>
);
  },
},

      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ value }) => (
          <Cell text={dayjs(value).format("D MMM YYYY , h:mm A")} />
        ),
      },

      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => {
          const user = row.original;

          const updateStatus = async (status) => {
            try {
              await axios.put("updateKyc", {
                userId: user.user,
                status,
                rejectionType: rejectType,
              });

              errorToast("Status Updated");
            } catch (err) {
              errorToast("Update failed");
            }
          };

          return (
            <Menu>
              <MenuButton as={Button} className="bg-purple text-white">
                Actions
              </MenuButton>

              <MenuList>
                <MenuItem
                  onClick={() => {
                    setSelectedUser(user);
                    setStatusType(""); // reset
                    onRejectOpen();
                  }}
                >
                  View
                </MenuItem>

                <MenuDivider />

                <MenuItem
                  onClick={() => {
                    setNewID(user);
                    onOpen();
                  }}
                >
                  <MdEdit className="mr-2" /> Edit
                </MenuItem>
              </MenuList>
            </Menu>
          );
        },
      },
    ],
    [],
  );

  return (
    <div
      className="lg:py-8 py-4 bg-bgWhite"
      // style={{
      //   backgroundImage: `url('${bgImage}')`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center",
      // }}
    >
      <section class=" md:p-1 ">
        <div class="py-4 ">
          <div class="flex  justify-between items-center">
            <div>
              <h2 class="text-xl font-bold  mb-4 text-purple text-oswald">
                KYC User
              </h2>
             <div className="flex gap-4 mb-4">
  <button
    onClick={() => setFilterStatus("pending")}
    className={`px-4 py-2 rounded ${
      filterStatus === "pending"
        ? "bg-yellow-500 text-white"
        : "bg-yellow-100 text-yellow-700"
    }`}
  >
    Pending: {statusCount.pending}
  </button>

  <button
    onClick={() => setFilterStatus("verified")}
    className={`px-4 py-2 rounded ${
      filterStatus === "verified"
        ? "bg-green-500 text-white"
        : "bg-green-100 text-green-700"
    }`}
  >
    Verified: {statusCount.verified}
  </button>

  <button
    onClick={() => setFilterStatus("rejected")}
    className={`px-4 py-2 rounded ${
      filterStatus === "rejected"
        ? "bg-red-500 text-white"
        : "bg-red-100 text-red-700"
    }`}
  >
    Rejected: {statusCount.rejected}
  </button>

  {/* RESET BUTTON */}
  <button
    onClick={() => setFilterStatus("")}
    className="px-4 py-2 rounded bg-gray-200 text-gray-700"
  >
    All
  </button>
</div>
            </div>
            <UserTableControls
              search={searchText}
              onSearchChange={setSearchText}
              sortOptions={[
                { label: "Sort by Name", value: "name" },
                { label: "Sort by Date", value: "date" },
                { label: "Reset", value: "" },
              ]}
              onSortChange={setSortType}
              showFilter
              filterButtonRef={btnRef}
              onFilterOpen={onOpen2}
            />
            <Drawer
              isOpen={isOpen2}
              placement="right"
              onClose={onClose2}
              finalFocusRef={btnRef}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Filter by Status</DrawerHeader>
                <Select
                  placeholder="Filter by Status"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                >
                  <option value="pending">Pending</option>
                  <option value="verified">Verified</option>
                  <option value="rejected">Rejected</option>
                </Select>

                <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose2}>
                    Cancel
                  </Button>
                  <Button colorScheme="blue">Save</Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>
          </div>
          <div className="mt-2">
            <Table
              // isLoading={isLoading}
              data={paginatedData || []}
              columns={columns}
              total={finalData.length}
              pageSize={pageSize}
              currentPage={page}
              onPageChange={setPage}
            />
          </div>
          <Modal isOpen={isRejectOpen} onClose={onRejectClose} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>KYC Details</ModalHeader>
              <ModalCloseButton />

              <ModalBody>
               {selectedUser && (
  <>
    <p><b>Name:</b> {selectedUser.holderName}</p>
    <p><b>Email:</b> {selectedUser.email}</p>
    <p><b>Mobile:</b> {selectedUser.mobile}</p>
    <p><b>Bank:</b> {selectedUser.bankName}</p>
    <p><b>Account No:</b> {selectedUser.accountNo}</p>
    <p><b>IFSC:</b> {selectedUser.ifsc}</p>
    <p><b>Aadhar:</b> {selectedUser.aadharNo}</p>
    <p><b>UPI:</b> {selectedUser.upiId}</p>
    <p><b>Status:</b> {selectedUser.status}</p>
    <p><b>Rejection Type:</b> {selectedUser.rejectionType || "No Rejection Type Provided"}</p>
    <p><b>Rejection Reason:</b> {selectedUser.rejectionReason || "No Reason Provided"}</p>

    {/* 🔥 Images Section */}
    <div className="mt-4">
      <p><b>Document Front:</b></p>
      {selectedUser.documentFrontImage ? (
        <button
          type="button"
          onClick={() => setSelectedImage(selectedUser.documentFrontImage)}
          className="mb-3 block focus:outline-none focus:ring-2 focus:ring-purple"
        >
          <img
            src={selectedUser.documentFrontImage}
            alt="Front Document"
            className="w-40 h-40 object-cover border rounded cursor-pointer"
          />
        </button>
      ) : (
        <p>No Image</p>
      )}

      <p><b>Document Back:</b></p>
      {selectedUser.documentBackImage ? (
        <button
          type="button"
          onClick={() => setSelectedImage(selectedUser.documentBackImage)}
          className="block focus:outline-none focus:ring-2 focus:ring-purple"
        >
          <img
            src={selectedUser.documentBackImage}
            alt="Back Document"
            className="w-40 h-40 object-cover border rounded cursor-pointer"
          />
        </button>
      ) : (
        <p>No Image</p>
      )}
    </div>
  </>
)}

                {/* Reject Form */}
                {statusType === "rejected" && (
                  <>
                    <Select
                      mt={3}
                      value={rejectType}
                      onChange={(e) => setRejectType(e.target.value)}
                    >
                      <option value="kyc">KYC Issue</option>
                      <option value="banking">Banking Issue</option>
                    </Select>

                    <Input
                      mt={3}
                      placeholder="Enter rejection reason"
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                    />
                  </>
                )}
              </ModalBody>

              <ModalFooter>
                <Button variant="outline" mr={3} onClick={onRejectClose}>
                  Close
                </Button>

                {/* Verify Button */}
                {statusType !== "rejected" && (
                  <>
                    <Button
                      colorScheme="green"
                      mr={3}
                      onClick={async () => {
                        try {
                          await axios.put("updateKyc", {
                            userId: selectedUser.user,
                            status: "verified",
                          });

                          successToast("KYC Verified");
                          onRejectClose();
                        } catch {
                          errorToast("Failed");
                        }
                      }}
                    >
                      Verify
                    </Button>

                    <Button
                      colorScheme="red"
                      onClick={() => setStatusType("rejected")}
                    >
                      Reject
                    </Button>
                  </>
                )}

                {/* Final Reject Submit */}
                {statusType === "rejected" && (
                  <Button
                    colorScheme="red"
                    onClick={async () => {
                      try {
                        await axios.put("updateKyc", {
                          userId: selectedUser.user,
                          status: "rejected",
                          rejectionType: rejectType,
                          rejectionReason: rejectReason,
                        });

                        errorToast("KYC Rejected");
                        setRejectReason("");
                        setStatusType("");
                        onRejectClose();
                      } catch {
                        errorToast("Failed");
                      }
                    }}
                  >
                    Submit Reject
                  </Button>
                )}
              </ModalFooter>
            </ModalContent>
          </Modal>
          <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader>Edit KYC</DrawerHeader>

              <DrawerBody>
                <Input
                  placeholder="Holder Name"
                  value={newID?.holderName || ""}
                  onChange={(e) =>
                    setNewID({ ...newID, holderName: e.target.value })
                  }
                  mb={3}
                />

                <Input
                  placeholder="Bank Name"
                  value={newID?.bankName || ""}
                  onChange={(e) =>
                    setNewID({ ...newID, bankName: e.target.value })
                  }
                  mb={3}
                />

                <Input
                  placeholder="Account Number"
                  value={newID?.accountNo || ""}
                  onChange={(e) =>
                    setNewID({ ...newID, accountNo: e.target.value })
                  }
                  mb={3}
                />

                <Input
                  placeholder="IFSC"
                  value={newID?.ifsc || ""}
                  onChange={(e) => setNewID({ ...newID, ifsc: e.target.value })}
                />
              </DrawerBody>

              <DrawerFooter>
                <Button variant="outline" mr={3} onClick={onClose}>
                  Cancel
                </Button>

                <Button
                  colorScheme="blue"
                  onClick={async () => {
                    try {
                      const { user, holderName, bankName, accountNo, ifsc } =
                        newID;

                      await axios.put("updateKyc", {
                        userId: user,
                        holderName,
                        bankName,
                        accountNo,
                        ifsc,
                      });

                      errorToast("KYC Updated Successfully");

                      onClose();
                    } catch (err) {
                      errorToast("Update Failed");
                    }
                  }}
                >
                  Save
                </Button>
              </DrawerFooter>
            </DrawerContent>
          </Drawer>
          {selectedImage && (
            <div
              className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-75 p-4"
              onClick={() => setSelectedImage(null)}
            >
              <div className="relative max-h-full max-w-4xl">
                <button
                  type="button"
                  onClick={() => setSelectedImage(null)}
                  className="absolute -right-2 -top-2 rounded-full bg-white px-3 py-1 text-lg font-bold text-gray-800 shadow"
                >
                  x
                </button>
                <img
                  src={selectedImage}
                  alt="Preview"
                  className="max-h-[85vh] max-w-full rounded-lg bg-white object-contain"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default KycUser;
